import { addUserParams, updateUserParams } from "dto/userDto";
import {
  deleteWithAuth,
  getWithAuth,
  postWithAuth,
  putWithAuth,
} from "utilities/api";

export async function getAllUser(
  accessToken: string,
  appId: string = "",
  searchString: string = "",
  excludeAttacheduser: boolean = false,
  currentPageNumber: number = 1,
  itemPerPage: number = 15,
  isNotification: boolean = false
) {
  if (appId !== "") {
    appId = "appId=" + appId + "&";
  }

  if (searchString !== "") {
    searchString = "searchString=" + searchString + "&";
  }

  var url =
    window.env.baseURL;

  if(!isNotification) {
    url += `user?${appId}${searchString}excludeAttacheduser=${excludeAttacheduser}&currentPageNumber=${currentPageNumber}&itemPerPage=${itemPerPage}`; 
  }
  else {
    url += `user/notification?${appId}${searchString}excludeAttacheduser=${excludeAttacheduser}&currentPageNumber=${currentPageNumber}&itemPerPage=${itemPerPage}`; 
  }

  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function getUserById(accessToken: string, id: number) {
  var url = window.env.baseURL + `user/${id}`;
  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function addNewUser(accessToken: string, params: addUserParams) {
  var url = window.env.baseURL + "user";

  return postWithAuth(url, accessToken, params).then((response) => {
    return response;
  });
}

export async function deleteUserbyId(accessToken: string, id: number) {
  var url = window.env.baseURL + `user/${id}`;

  return deleteWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function updateUserbyId(
  accessToken: string,
  id: number,
  params: updateUserParams
) {
  var url = window.env.baseURL + `user/${id}`;
  return putWithAuth(url, accessToken, params).then((response) => {
    return response;
  });
}

export async function deleteUsers(accessToken: string, userIdList: number[]) {
  var url = window.env.baseURL + `user/delete`;

  return putWithAuth(url, accessToken, { userIdList: userIdList }).then(
    (response) => {
      return response;
    }
  );
}

export async function changeRoles(accessToken: string, userIdList: number[]) {
  var url = window.env.baseURL + `user/changeRole`;
  console.log({ userIdList: userIdList });
  return putWithAuth(url, accessToken, { userIdList: userIdList }).then(
    (response) => {
      return response;
    }
  );
}

export async function getAssignedApplications(
  accessToken: string,
  userId: number
) {
  var url =
    window.env.baseURL;

  url += `user/${userId}/assigned-applications`; 

  return getWithAuth(url, accessToken).then((response) => {
    return response;
  });
}

export async function subscribeNotificationToApp(
  accessToken: string,
  appid: number,
  userid: number
) {
  var url = window.env.baseURL + `user/${userid}/grantNotification/${appid}`;
  return postWithAuth(url, accessToken).then(
    (response) => {
      return response;
    }
  );
}

export async function unsubscribeNotificationFromApp(
  accessToken: string,
  appid: number,
  userid: number
) {
  var url = window.env.baseURL + `user/${userid}/removeNotification/${appid}`;
  return putWithAuth(url, accessToken).then(
    (response) => {
      return response;
    }
  );
}